/**
 * PC 用のメディアクエリ文字列
 *
 * constants.css の --pcOnly の条件と同期する必要がある。
 *
 * 主に HTML 上でメディアクエリを書く必要がある picture 要素に対して使うことを想定している。
 */
export const PC_ONLY_MEDIA_QUERY = '(min-width: 960px)';

/**
 * 旧デザインのページ。
 */
export const LEGACY_DESIGN_PAGES: string[] = [
  '/antisocial',
  '/by-your-side',
  '/lp-offline-payment-cashback-20241021',
  '/lp-payment-cashback-202412',
  '/lp-10milliondownloads-cashback-campaign-20240305',
  '/lp-10milliondownloads-cashback-campaign-20240503',
  '/lp-11milliondownloads-cashback-campaign-20240909',
  '/lp-age-verification-campaign-202409',
  '/lp-age-verification-campaign-202407-in-app',
  '/lp-age-verification-campaign-202407',
  '/lp-age-verification-campaign-in-app',
  '/lp-age-verification-campaign',
  '/lp-3ds-campaign-20220708',
  '/lp-campaign-android',
  '/lp-campaign-potato',
  '/lp-card-campaign-20200217',
  '/lp-card-campaign-20200417',
  '/lp-card-campaign-20200521',
  '/lp-card-campaign-20200622',
  '/lp-card-campaign-20200716',
  '/lp-card-campaign-20200727',
  '/lp-card-campaign-20200817',
  '/lp-card-campaign-20200825',
  '/lp-card-campaign-20200915',
  '/lp-card-campaign-20200924',
  '/lp-card-campaign-20200928',
  '/lp-card-campaign-20201221',
  '/lp-card-campaign-20210127',
  '/lp-card-campaign-20210326',
  '/lp-card-campaign-20210617',
  '/lp-card-campaign-20220214-normal',
  '/lp-card-campaign-20220214-plus',
  '/lp-family',
  '/lp-lordsmobile',
  '/lp-luup-campaign-20241125',
  '/lp-marathon-20201116',
  '/lp-marathon-20201210',
  '/lp-mau-load-201708',
  '/lp-mau-load-201709-3',
  '/lp-mau-load-201709-4',
  '/lp-mau-load-201709',
  '/lp-mynumber-point',
  '/lp-new-pochi-charge-20200210-2',
  '/lp-new-pochi-charge-20200210',
  '/lp-omikuji-201701',
  '/lp-otoshidama-2017',
  '/lp-payeasy-201705',
  '/lp-payeasy-201707',
  '/lp-pochi-charge-04-20200615',
  '/lp-pochi-charge-05-20200615',
  '/lp-pochi-charge-20200210',
  '/lp-pochi-charge-20200421',
  '/lp-pochi-charge-20200825',
  '/lp-pochi-charge-20210317',
  '/lp-pochi-payment-20200827',
  '/lp-real-card-campaign-202204',
  '/lp-real-card-campaign-202206',
  '/lp-real-card-campaign-202208',
  '/lp-real-card-campaign-202211',
  '/lp-real-card-campaign-202303',
  '/lp-real-card-campaign-20240909',
  '/lp-real-card-campaign-202411',
  '/lp-realplus-card-campaign-20210614',
  '/lp-realplus-card-campaign-202204',
  '/lp-realplus-card-campaign-202206',
  '/lp-realplus-card-campaign-202208',
  '/lp-realplus-card-campaign-202303',
  '/lp-realplus-card-campaign-202311',
  '/lp-real-plus-campaign-20241225',
  '/lp-sevenbank-201903',
  '/lp-sevenbank-202105',
  '/lp-sevenbank-20211201',
  '/lp-sevenbank-20220301',
  '/lp-sevenbank-20241201',
  '/lp-sevenbank',
  '/lp-sixtypercent-20250407',
  '/lp-lawsonbank-202503',
  '/lp-spring-pochitto-cp-20200325',
  '/lp-subscription-campaign-20220316',
  '/lp-twitter-campaign-202205',
  '/lp-web',
  '/lp-youtuber-shopping',
  '/lp-cashback-cp-202501-a',
  '/lp-cashback-cp-202501-c',
  '/pochitto',
  '/privacy-policy-202204',
  '/privacy-policy',
  '/settlement',
  '/docs',
  '/terms',
];

/**
 * 旧デザインのページの html 要素へ付与する className。CSS で使用される。
 */
export const HTML_CLASS_NAME_FOR_LEGACY_DESIGN_PAGES: string = 'legacy';
